module.exports = __webpack_public_path__ + "8cb54155a8fdc2df789aec0f8ac53542.mp3";